export function formatCurrency({ amount = 0, currency, locale, decimalCount } = {}) {
    const amountNumber = Number(amount);
    if (currency) {
        const fractionDigits = decimalCount ?? getDisplayPrecision(amountNumber);
        return Intl.NumberFormat(locale, {
            style: 'currency',
            unitDisplay: 'narrow',
            currency,
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        }).format(amountNumber);
    }
    if (decimalCount) {
        return amountNumber.toFixed(decimalCount);
    }
    return String(amount);
}
function getDisplayPrecision(amount) {
    return Number.isInteger(amount) ? 0 : 2;
}

//# sourceMappingURL=format-currency.js.map